/**
 * DevExtreme (ui/pivot_grid_field_chooser.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./pivot_grid/ui.pivot_grid.field_chooser");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme/ui/pivot_grid_field_chooser.js
// module id = ../../../../devextreme/ui/pivot_grid_field_chooser.js
// module chunks = 3